export default __webpack_public_path__ + "static/studyoffice-office3-f431c2f22c32401cb2549309d0a7dc97.jpg";